export default "__VITE_ASSET__HT_mvOrW__"